import { Params, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ActionReducerMap, createFeatureSelector, createSelector, MetaReducer } from '@ngrx/store';
import { storeFreeze } from 'ngrx-store-freeze';
import { environment } from '../../../../environments/environment';

import * as fromRouter from '@ngrx/router-store';
import * as fromAuth from './auth.reducers';
import * as fromNavigation from './navigation.reducer';
import * as fromApp from './app.reducers';
import * as fromLookup from './lookup.reducers';
import * as fromBuilding from './building.reducers';
import * as fromRequest from './request.reducers';
import * as fromDashboard from './dashboard.reducers';

export interface RouterStateUrl {
  url: string;
  queryParams: Params;
  params: Params;
  data: any;
  pageTitle: string;
}

export interface State {
  router: fromRouter.RouterReducerState<RouterStateUrl>;
  auth: fromAuth.State;
  navigation: fromNavigation.State;
  app: fromApp.State;
  lookup: fromLookup.State;
  building: fromBuilding.BuildingState;
  request: fromRequest.State,
  dashboard: fromDashboard.State,
}

export const reducers: ActionReducerMap<State> = {
  router: fromRouter.routerReducer,
  auth: fromAuth.reducer,
  navigation: fromNavigation.reducer,
  app: fromApp.reducer,
  lookup: fromLookup.reducer,
  building: fromBuilding.reducer,
  request: fromRequest.reducer,
  dashboard: fromDashboard.reducer,
};

export const metaReducers: MetaReducer<State>[] = !environment.production ? [storeFreeze] : [];


export const selectRouterState = createFeatureSelector<fromRouter.RouterReducerState<RouterStateUrl>>('router');
export const selectAuthState = createFeatureSelector<fromAuth.State>('auth');
export const selectNavigationState = createFeatureSelector<fromNavigation.State>('navigation');
export const selectAppState = createFeatureSelector<fromApp.State>('app');
export const selectLookupState = createFeatureSelector<fromLookup.State>('lookup');
export const selectBuildingState = createFeatureSelector<fromBuilding.BuildingState>('building');
export const selectRequestState = createFeatureSelector<fromRequest.State>('request');
export const selectDashboardState = createFeatureSelector<fromDashboard.State>('dashboard');

export class CustomSerializer implements fromRouter.RouterStateSerializer<RouterStateUrl> {
  serialize(routerState: RouterStateSnapshot): RouterStateUrl {
    const { url } = routerState;
    const { queryParams } = routerState.root;
    let state: ActivatedRouteSnapshot = routerState.root;
    while (state.firstChild) {
      state = state.firstChild;
    }
    const { params } = state;
    const { data } = state;
    return { url, queryParams, params, data, pageTitle: data['title'] };    
  }
}



// WEBPACK FOOTER //
// ./src/app/core/store/reducers/index.ts